import React from 'react';

import {
  getDisplayOperatorAndOperatorDropdown,
  getValueNodesFactory,
  StandardFilterFormProps,
} from 'search/filters/base/StandardFilterFormComponents';
import {
  FILTERS,
  RELATIVE_RANGE_SHORTCUT_OPERATORS,
  StandardFilterDataType,
  VALUELESS_OPERATORS,
} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, FilterStyle} from './FilterFormConstants';
import FilterFormSkeletonNodeLayout from './FilterFormSkeletonNodeLayout';
import PrimaryFilterFormSkeleton from './PrimaryFilterFormSkeleton';
import SecondaryFilterFormSkeleton from './SecondaryFilterFormSkeleton';

export default function StandardFilterForm(props: StandardFilterFormProps): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const filterKey = props.filter.key;
  if (!FILTERS[filterKey].dataType) {
    throw new Error(`Standard filter ${filterKey} is missing a data type.`);
  }
  const filterDataType: StandardFilterDataType = FILTERS[filterKey].dataType;

  if (filterDataType === StandardFilterDataType.ENUM) {
    throw new Error(
      'Enum filters are not supported by StandardFilterForm. Use StandardEnumFilterForm instead.'
    );
  }

  const [displayOperator, operatorDropdown] = getDisplayOperatorAndOperatorDropdown(
    props.filter,
    props.onChangeFilter,
    props.buttonSize,
    props.operators,
    props.isDirty
  );

  const nodeGrid: Array<Array<JSX.Element>> = [[operatorDropdown]];
  if (
    !VALUELESS_OPERATORS.includes(displayOperator) &&
    !RELATIVE_RANGE_SHORTCUT_OPERATORS.includes(displayOperator)
  ) {
    const nodesFactory = getValueNodesFactory(filterDataType);
    nodeGrid.push(nodesFactory(props));
  }

  if (props.filterStyle === FilterStyle.PRIMARY) {
    return (
      <PrimaryFilterFormSkeleton
        {...skeletonProps}
        content={<FilterFormSkeletonNodeLayout nodeGrid={nodeGrid} />}
        dropdownToggleText={props.dropdownToggleText}
      />
    );
  } else {
    if (!props.onRemove) {
      throw new Error('Expected props.onRemove to be present when filterStyle is SECONDARY');
    }
    return (
      <SecondaryFilterFormSkeleton
        {...skeletonProps}
        nodeGrid={nodeGrid}
        onChangeFilterKey={props.onChangeFilterKey}
        selectedFilterKey={props.selectedFilterKey}
        onRemove={props.onRemove}
      />
    );
  }
}
